import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Donation {
    currency: string;
    payment_type: string;
    amount: number;
    frequency: string;
    donation_type: string;
    currency_with_symbol: string;
}

interface DonationState {
    donation: Donation | null; // Single object instead of an array
}

const initialState: DonationState = {
    donation: null, // Initialize as null
};

const donationSlice = createSlice({
    name: "donation",
    initialState,
    reducers: {
        saveDonationInfo: (state, action: PayloadAction<Donation>) => {
            state.donation = action.payload; // Store as a single object
        },
    },
});

export const { saveDonationInfo } = donationSlice.actions;
export default donationSlice.reducer;
